import type { AnalyticsContext, AnalyticsPage } from "@shuttlerock/observability";
import type { createBrowserRouter } from "react-router";

type RouterState = ReturnType<typeof createBrowserRouter>["state"];

export function analyticsRoute(state: RouterState): Pick<AnalyticsContext, "pathname" | "page"> {
  const { location, matches } = state;
  const match = matches.at(-1);
  const page: AnalyticsPage = { routeId: match?.route.id ?? "unmatched" };
  const resourceKeys = [
    "projectKey",
    "conceptKey",
    "creativeKey",
    "specificationKey",
    "revisionSequenceId",
    "generativeEditKey",
  ] as const;
  for (const key of resourceKeys) {
    const value = match?.params[key];
    if (value) page[key] = value;
  }
  // Query and hash changes (filters, selections, anchors) stay on the same page.
  return { pathname: location.pathname, page };
}
